import { Prefix } from "@/types/debug-mode";

// Used to display preview watched prefixes, before any prefixes have been watched
export const PREVIEW_PREFIXES: Prefix[] = [
  {
    id: 0,
    name: "sample_prefix_a",
  },
  {
    id: 1,
    name: "sample_prefix_b",
  },
  {
    id: 2,
    name: "sample_prefix_c",
  },
];

// Used to display preview watched prefix stats, before any prefixes have been watched
// The number of items in this array must correspond to the number of items in
// PREVIEW_PREFIXES, plus 1 for sum
// The prop names must correspond to those displayed in PrefixItemStats
const requestsA = 21;
const requestsB = 16;
const requestsC = 53;

const numKeysA = 34;
const numKeysB = 2;
const numKeysC = 25;

const totalSizeA = 65;
const totalSizeB = 0;
const totalSizeC = 29;

const hitRateA = 99;
const hitRateB = 95;
const hitRateC = 96;

// TODO add request fraction
export const PREVIEW_PREFIXES_STATS: { [propName: string]: string }[] = [
  {
    prefix_over_compound_requests: `${requestsA}%`,
    prefix_over_compound_num_keys: `${numKeysA}%`,
    prefix_over_compound_total_size: `${totalSizeA}%`,
    prefix_hit_rate: `${hitRateA}%`,
  },
  {
    prefix_over_compound_requests: `${requestsB}%`,
    prefix_over_compound_num_keys: `${numKeysB}%`,
    prefix_over_compound_total_size: `${totalSizeB}%`,
    prefix_hit_rate: `${hitRateB}%`,
  },
  {
    prefix_over_compound_requests: `${requestsC}%`,
    prefix_over_compound_num_keys: `${numKeysC}%`,
    prefix_over_compound_total_size: `${totalSizeC}%`,
    prefix_hit_rate: `${hitRateC}%`,
  },
  // sum should always be last item, used for Watched Totals in PrefixesOverallStats
  // hit rate not required for Watched Totals
  {
    prefix_over_compound_requests: `${requestsA + requestsB + requestsC}%`,
    prefix_over_compound_num_keys: `${numKeysA + numKeysB + numKeysC}%`,
    prefix_over_compound_total_size: `${totalSizeA + totalSizeB + totalSizeC}%`,
  },
];
